import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Badge, PageHeader, Descriptions, Tag } from "antd";
import "antd/dist/antd.min.css";
import { getSelectedAdminSelector } from "../Infrastructure/Administrators.reducer";
import { deselectAdmin } from "../Infrastructure/Administrators.store";
import { CustomCard } from "../../Utils/UI/Text";

export default function AdminsForm() {
  const selected = useSelector(getSelectedAdminSelector);
  const navigate = useNavigate();

  const cancel = () => {
    deselectAdmin();
    navigate("/administrator");
  };

  return selected ? (
    <CustomCard>
      <PageHeader
        className="site-page-header"
        onBack={cancel}
        tags={<Tag color="green">{selected.name}</Tag>}
        avatar={{
          src: "https://avatars1.githubusercontent.com/u/8186664?s=460&v=4",
        }}
      >
        <Descriptions
          layout="vertical"
          className="custom-descriptions"
          bordered
          column={{
            xxl: 2,
            xl: 2,
            lg: 2,
            md: 1,
            sm: 1,
            xs: 1,
          }}
          size="small"
          style={{ width: "100%" }}
        >
          <Descriptions.Item label="Nombre" span={2}>
            {selected.name}
          </Descriptions.Item>
          <Descriptions.Item label="Email" span={3}>
            {selected.email}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            {selected.verifiedValue}
          </Descriptions.Item>
          <Descriptions.Item label="Activo">
            <Badge status="processing" text={selected.enabledValue} />
          </Descriptions.Item>
          <Descriptions.Item label="Withdrew Usd">
            {selected.withdrew_usd}
          </Descriptions.Item>
          <Descriptions.Item label="Public Key">
            {selected.publicKey}
          </Descriptions.Item>
        </Descriptions>
        ,
      </PageHeader>
    </CustomCard>
  ) : (
    <div />
  );
}
